import { LOCATION_CHANGE } from 'redux-first-history';
import {
  CLIENT_DETAILS_GET,
  CLIENT_ACCOUNTS_GET,
  CLIENT_ASSETS_BREAKDOWN_GET,
} from '../actions/types';
import { faPaths } from '../../paths';

const initialState = {
  clientId: null,
  clientDetails: {},
  accounts: {},
  assetsBreakdown: {},
};

const getClientId = (location) => {
  const locArray = location.pathname.toLowerCase().split('/');
  const pathArray = faPaths.clients.complete.split('/');

  for (let i = 0; i < pathArray.length; i += 1) {
    if (i >= locArray.length || pathArray[i] !== locArray[i]) return null;
  }

  const id = locArray[pathArray.length];
  const uuidRegex = new RegExp(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i);
  if (uuidRegex.test(id)) return id;

  return null;
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CLIENT_DETAILS_GET._SUCCESS: {
      const { clientDetails } = action.payload;
      state.clientDetails[clientDetails.clientId] = clientDetails;
      return state;
    }
    case CLIENT_ACCOUNTS_GET._SUCCESS: {
      const { accounts, clientId } = action.payload;
      state.accounts[clientId] = accounts;
      return state;
    }
    case LOCATION_CHANGE: {
      const { location } = action.payload;
      state.clientId = getClientId(location);
      return state;
    }
    case CLIENT_ASSETS_BREAKDOWN_GET._SUCCESS: {
      const { clientId, breakdowns } = action.payload;
      state.assetsBreakdown[clientId] = breakdowns;
      return state;
    }
    default:
      return state;
  }
};

export { reducer as clients };
